
export {ClayMultiStepNavWithBasicItems} from '@clayui/multi-step-nav';
import __x__ from '@clayui/multi-step-nav';export default __x__;